import React from "react";

const NavigationToggle = ({ toggleNavigation }) => {
  return (
    <button
      onClick={toggleNavigation}
      className="toggle-button ms-3 btn btn-primary"
    >
      Menu
    </button>
  );
};

export default NavigationToggle;
